export * as Basket from './basket';
export enum FareType {
  Standard = 0,
  Flexi = 1,
  Promo = 2,
  Unknown = 4
}

// We should not hard code bundle types as they will be dynamic
export enum BundleType {
  NoBundle = 0,
  HasBundle = 1,
  Unknown = 2
}

export type AuthResponse = {
  isAuthenticated: boolean;
};
